import React from 'react';
import { FileText } from 'lucide-react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <FileText className="w-16 h-16 mx-auto text-slate-700 mb-4" />
            <h1 className="text-4xl font-bold text-slate-900 mb-4">Terms & Conditions</h1>
            <p className="text-slate-600">Last updated: {new Date().toLocaleDateString()}</p>
          </div>
          
          <div className="bg-white rounded-xl shadow-sm p-8 lg:p-12 space-y-8">
            <div className="prose prose-slate max-w-none">
              <p className="text-lg text-slate-600">
                Please review our complete Terms & Conditions in the Au Pair Share app for the most current and detailed information regarding use of our services.
              </p>
              
              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Overview</h2>
              <p className="text-slate-700 leading-relaxed">
                By using Au Pair Share services, you agree to these terms and conditions. Our platform connects families with vetted au pairs — both students and qualified childcare professionals — for flexible childcare services across South Africa, including Johannesburg, Pretoria, Cape Town, and Durban.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Service Description</h2>
              <p className="text-slate-700 leading-relaxed">
                Au Pair Share is a platform service that facilitates connections between families seeking childcare and qualified au pairs (students and childcare professionals). We are not a childcare agency. All bookings, matching, and service delivery are managed through our app.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">User Responsibilities</h2>
              <ul className="list-disc list-inside text-slate-700 space-y-2">
                <li>Provide accurate and up-to-date information</li>
                <li>Comply with all applicable laws and regulations</li>
                <li>Treat all parties with respect and professionalism</li>
                <li>Report any safety concerns or incidents immediately</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Safety & Compliance</h2>
              <p className="text-slate-700 leading-relaxed">
                Au Pair Share maintains compliance with South African regulations including the Children's Act and POPIA. All au pairs undergo verification and background checks before approval.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Liability</h2>
              <p className="text-slate-700 leading-relaxed">
                Detailed liability terms, insurance coverage, and dispute resolution procedures are outlined in the full Terms & Conditions available in the app.
              </p>

              <div className="bg-slate-50 rounded-lg p-6 mt-8">
                <p className="text-slate-700 font-medium">
                  For complete Terms & Conditions, please visit the Au Pair Share app or contact our support team.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
